import { useTranslation } from "react-i18next";
import CustomTooltip from "shared/components/CustomTooltip";
import styled, { css } from "styled-components/macro";

function SolutionLabel({ variant, icon, text }) {
	const { t } = useTranslation();

	return (
		<Card className="px-1" variant={variant}>
			<span style={{ fontFamily: "Font Name, sans-serif", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.1em" }}>{icon}</span>
			<CustomTooltip text={t(text)}>
				<CardText className="me-2">{t(text)}</CardText>
			</CustomTooltip>
		</Card>
	);
}

SolutionLabel.displayName = "SolutionLabel";
export default SolutionLabel;

const Card = styled.div`
	z-index: 9999 !important;
	position: absolute;
	display: flex;
	align-items: center;
	gap: 5px;
	height: 30px;
	border-radius: 6px;
	background: #f5f5f5;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #c4c4c4;
	transform: rotate(-90deg);

	${(props) =>
		props.variant === "quickWin" &&
		css`
			background: #e7efff;
			color: #3353e0;
			left: -35px;
			top: 75px;
		`}
	${(props) =>
		props.variant === "niceToHave" &&
		css`
			background: #fdf7d0;
			color: #6f5608;
			left: -35px;
			bottom: 85px;
		`}
    ${(props) =>
		props.variant === "complexProj" &&
		css`
			background: #ededed;
			color: #595959;
			right: -65px;
			top: 80px;
		`}
    ${(props) =>
		props.variant === "toAvoid" &&
		css`
			background: #fdeae8;
			color: #bc2722;
			right: -65px;
			bottom: 85px;
		`}
`;

const CardText = styled.div`
	white-space: nowrap;
	width: 90px;
	height: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
`;
